import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VideoLayout1 } from '@components/video/components/video-layout-1/model';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-video-layout-1',
  imports: [VideoComponent],
  templateUrl: './video-layout-1.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoLayout1Component {
  readonly data = input.required<VideoLayout1>();
}
